import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../core/state-mangement/session/session.service';

@Component({
  selector: 'app-toggle-menu-button',
  templateUrl: './toggle-menu-button.component.html',
  styleUrls: ['./toggle-menu-button.component.scss'],
})
export class ToggleMenuButtonComponent implements OnInit {
  constructor(private sessionService: SessionService) {}

  ngOnInit() {}

  toggleMenu() {
    const splitPane = document.querySelector('ion-split-pane');
    const windowWidth = window.innerWidth;
    const splitPaneShownAt = 992;
    const when = `(min-width: ${splitPaneShownAt}px)`;

    this.sessionService.toggleMenu();

    if (windowWidth >= splitPaneShownAt) {
      // split pane view is visible
      const open = splitPane.when === when;
      splitPane.when = open ? false : when;
    } else {
      // split pane view is not visible
      // toggle menu open

      const menu = splitPane.querySelector('ion-menu');
      return menu.open();
    }
  }
}
